export default __webpack_public_path__ + "static/media/CafeAvion-4.33eb6af1.jpg";